import { isString } from "../utils/schemaUtils";

export interface GitHubCheck {
  name: string;
  app?: string;
  status: string;
  conclusion?: string;
  url?: string;
  completedAt?: string;
}

const isGitHubCheck = (v: unknown): v is GitHubCheck => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return (
    isString(r.name) &&
    (r.app === undefined || isString(r.app)) &&
    isString(r.status) &&
    (r.conclusion === undefined || isString(r.conclusion)) &&
    (r.url === undefined || isString(r.url)) &&
    (r.completedAt === undefined || isString(r.completedAt))
  );
};

// "none" means the ref has no checks at all, which is not the same as green, so
// it is a state of its own rather than an empty passing card.
export type GitHubRollup = "passing" | "failing" | "pending" | "none";

const ROLLUPS: ReadonlySet<GitHubRollup> = new Set(["passing", "failing", "pending", "none"]);

const isRollup = (v: unknown): v is GitHubRollup => typeof v === "string" && ROLLUPS.has(v as GitHubRollup);

export interface GitHubCIStatusPayload {
  type: "github_ci_status";
  repo: string;
  ref: string;
  rollup: GitHubRollup;
  checks: GitHubCheck[];
}

export const parseGitHubCIStatusPayload = (v: unknown): GitHubCIStatusPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "github_ci_status") return null;
  if (!isString(r.repo) || !isString(r.ref)) return null;
  if (!isRollup(r.rollup)) return null;
  if (!Array.isArray(r.checks) || !r.checks.every(isGitHubCheck)) return null;
  return {
    type: "github_ci_status",
    repo: r.repo,
    ref: r.ref,
    rollup: r.rollup,
    checks: r.checks,
  };
};
